import React, { useContext, useEffect, useRef, useState } from 'react'
import { Button, Dialog, Grid, IconButton, Typography } from '@mui/material'
import BackEndAPI from '../../../Services/BackEndAPI'
import { ContextoGlobal, ContextoGlobalInterface } from '../../../GlobalStates/ContextoGlobal'
import CloseIcon from '@mui/icons-material/Close'
import { ConsultaERP_PedidoInterface } from '../../../ImportBackend/Interfaces/ConsultaPedidoERPInterfaces'
import DataTable, { DataTableCabecalhoInterface } from '../../../DevComponents/DataTable'
import ClsFormatacao from '../../../Utils/ClsFormatacao'
import ExibirJSONDev from '../../../DevComponents/ExibirJSONDev'
import CustomTituloShow from './CustomTituloShow'
import CustomFieldShow from './CustomFieldShow'
import Condicional from '../../../Layout/Condicional'
import { SITUACAO_PEDIDO_APP } from '../../../ImportBackend/types/ConstantesDataTypes'
import { RespostaPadraoInterface } from '../../../ImportBackend/Interfaces/PadraoInterfaces'
import { EMDESENVOLVIMENTO } from '../../../ImportBackend/Config/emDesenvolvimento'

import SignatureCanvas from 'react-signature-canvas'

interface ModalComponentInterface {
  exibir: boolean
  idPedidoERP: number
  onFecharExibicao(pedidoCancelado: boolean): void
}

export default function PedidoShow({ exibir, idPedidoERP, onFecharExibicao }: ModalComponentInterface) {

  const assinaturaCanvas = useRef(null)
  const [rsAssinatura, setRsAssinatura] = useState<string>('')
  const [exibirPedidoAssinatura, setExibirPedidoAssinatura] = useState<boolean>(false)

  const clsFormatos: ClsFormatacao = new ClsFormatacao()

  const clsApi = new BackEndAPI()
  const contexto = useContext(ContextoGlobal) as ContextoGlobalInterface
  const { setMensagemState } = contexto
  const abortController: AbortController = new AbortController()

  const [exibirConfirmacaoCancelamento, setExibirConfirmacaoCancelamento] = useState<boolean>(false)

  const CabecalhoItens: Array<DataTableCabecalhoInterface> = [
    {
      cabecalho: 'Cod. Auxiliar',
      campo: 'produtoCodigoAuxiliar',
      alinhamento: 'left'
    },
    {
      cabecalho: 'Produto',
      campo: 'produto',
      alinhamento: 'left'
    },
    {
      cabecalho: 'QTD',
      campo: 'quantidadeTotal',
      alinhamento: 'right'
    },
    {
      cabecalho: 'Unidade',
      campo: 'unidadeMedida',
      alinhamento: 'left'
    },
    {
      cabecalho: 'Vr Unitário',
      campo: 'valorUnitario',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs)
    },
    {
      cabecalho: 'Vr Unitário Desc. Tributário',
      campo: 'valorUnitarioDescTrib',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs)
    },
    {
      cabecalho: 'Vr Acréscimo',
      campo: 'valorDespesaAcessoria',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs)
    },
    {
      cabecalho: '% Desconto',
      campo: 'percDesconto',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs).concat('%')
    },
    {
      cabecalho: 'Vr Líquido',
      campo: 'valorTotalComImpostos',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs, 2)
      // FIXME - Verificar impostos / Correcao de valor total
      // format: ( _v, rs ) => clsFormatos.currency( rs.valorTotalDescTrib ? rs.valorTotalDescTrib : rs.valorTotal )
    }
  ]

  const CabecalhoTitulos: Array<DataTableCabecalhoInterface> = [
    {
      cabecalho: 'Tipo',
      campo: 'tipoDoc',
      alinhamento: 'left'
    },
    {
      cabecalho: 'Vencimento',
      campo: 'dataVencimento',
      alinhamento: 'right',
      format: (rs) => clsFormatos.dateMillsParaDateUser(rs)
    },
    {
      cabecalho: 'Emissão',
      campo: 'dataEmissao',
      alinhamento: 'right',
      format: (rs) => clsFormatos.dateMillsParaDateUser(rs)
    },
    {
      cabecalho: 'Valor',
      campo: 'valor',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs)
    }
  ]

  const [rsPedido, setRsPedido] = useState<ConsultaERP_PedidoInterface>()

  const pesquisarERPPedido = () => {

    if (idPedidoERP > 0) {

      const query: string = `
        getERPPedido (
          idPedidoERP: ${idPedidoERP}
          ) 
      `

      clsApi.query<ConsultaERP_PedidoInterface>(query, 'getERPPedido', 'Pesquisando Pedido...', contexto, abortController).then((rs) => {

        setRsPedido(rs)

      })

      return () => {

        abortController.abort()
      }

    }

  }

  const onCancelarPedido = () => {

    const query: string = `
      cancelarPedidoERP (
        idPedidoERP: ${idPedidoERP}
      ) {
        ok
        mensagem
        }
    `

    clsApi.mutation<RespostaPadraoInterface>(query, 'cancelarPedidoERP', 'Cancelando Pedido...', contexto).then((rs) => {

      if (rs.ok) {

        pesquisarERPPedido()
        setExibirConfirmacaoCancelamento(false)
        onFecharExibicao(true)

      } else {

        setMensagemState({
          cb: null,
          exibir: true,
          exibirBotao: true,
          mensagem: rs.mensagem,
          tipo: 'error',
          titulo: 'Pedido Não Cancelado!'
        })

      }

    })

  }

  useEffect(() => {
    if (idPedidoERP && idPedidoERP > 0) {
      pesquisarERPPedido()
      getAssinatura()
    }

    // eslint-disable-next-line
  }, [idPedidoERP])

  const btDownload = () => {

    const query: string = `
      downloadPedido (
        idPedidoERP: ${idPedidoERP}
      ) 
    `

    clsApi.query<String>(query, 'downloadPedido', 'Baixando Pedido em PDF...', contexto).then((rs) => {

      // console.log( 'RS: ', rs )

      if (rs.length > 0) {
        // console.log( rs )
        const linkSource = `data:application/pdf;base64,${rs}`

        const downloadLink = document.createElement('a')
        document.body.appendChild(downloadLink)

        downloadLink.href = linkSource
        downloadLink.target = '_self'
        downloadLink.download = 'Pedido_'.concat(idPedidoERP.toString().trim())
        downloadLink.click()
        document.body.removeChild(downloadLink)

      } else {

        setMensagemState({
          cb: null,
          exibir: true,
          exibirBotao: true,
          mensagem: 'Erro ao Baixar PDF',
          tipo: 'error',
          titulo: 'Erro...!'
        })

      }

    })

  }

  const onSalvarAssinatura = () => {
    //@ts-ignore
    const assinatura: string = assinaturaCanvas.current.toDataURL()

    if (assinatura.length !== 0) {

      const mutation: string = `
        gravarAssinatura (
          idPedidoERP: ${idPedidoERP},
          assinatura: "${assinatura}"
        ) {
          ok
          mensagem
        }
      `

      clsApi.mutation<RespostaPadraoInterface>(mutation, 'gravarAssinatura', 'Verificando Assinatura do Pedido...', contexto).then((rs) => {

        if (!rs.ok) {

          setMensagemState({
            cb: null,
            exibir: true,
            exibirBotao: true,
            mensagem: rs.mensagem,
            tipo: 'error',
            titulo: 'Erro ao Salvar Assinatura!'
          })

        } else {

          setRsAssinatura(assinatura)
          setExibirPedidoAssinatura(false)
        }

      })

    }

  }

  const onCancelarAssinatura = () => {
    //@ts-ignore
    assinaturaCanvas.current.clear()
    setExibirPedidoAssinatura(false)
  }

  const getAssinatura = () => {

    const query: string = `
      getAssinaturaPorId (
        idPedidoERP: ${idPedidoERP}
      ) {
        ok
        mensagem
      }
    `

    clsApi.query<RespostaPadraoInterface>(query, 'getAssinaturaPorId', 'Verificando Assinatura do Pedido...', contexto).then((rs) => {
      if (rs.ok) {
        setRsAssinatura(rs.mensagem)
      } else {
        setRsAssinatura('')
      }
    })

  }

  return (
    <>
      <Dialog
        fullWidth
        maxWidth='lg'
        open={exibir}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >

        <Grid container sx={{ display: 'flex', alignItems: 'stretch', padding: 5 }}>
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
            <Typography component="h5" variant="h5" align="left">
              Resumo do Pedido
              <Typography variant="body2" gutterBottom>
                Dados extraídos do ERP
              </Typography>
            </Typography>

            <IconButton onClick={() => onFecharExibicao(false)}>
              <CloseIcon />
            </IconButton>
          </Grid>

          <CustomTituloShow titulo='Informações' />

          <CustomFieldShow titulo='Pedido' descricao={rsPedido?.identificador} />
          <CustomFieldShow titulo='Cliente' descricao={rsPedido?.clienteIdentificador} />
          <CustomFieldShow titulo='Unidade de Faturamento' descricao={rsPedido?.unidadeFatCliente} />
          <CustomFieldShow titulo='Empresa' descricao={rsPedido?.empresa} />
          <CustomFieldShow titulo='Situacao' descricao={rsPedido?.situacaoPedido} />
          {/*
          
          <CustomFieldShow titulo='Valor Total' descricao={clsFormatos.currency( rsPedido && rsPedido.valorTotal ? rsPedido.valorTotal : 0 )} />
          <CustomFieldShow titulo='Valor valorTotalBrutoDescTrib' descricao={clsFormatos.currency( rsPedido && rsPedido.valorTotalBrutoDescTrib ? rsPedido.valorTotalBrutoDescTrib : 0 )} />
          <CustomFieldShow titulo='Valor valorTotalBruto' descricao={clsFormatos.currency( rsPedido && rsPedido.valorTotalBruto ? rsPedido.valorTotalBruto : 0 )} />
          <CustomFieldShow titulo='Valor Acréscimo' descricao={clsFormatos.currency( rsPedido && rsPedido.valorDespAcessoria ? rsPedido.valorDespAcessoria : 0 )} />
          <CustomFieldShow titulo='Valor Desconto' descricao={clsFormatos.currency( rsPedido && rsPedido.valorDesconto ? rsPedido.valorDesconto : 0 )} />
          */}
          <CustomFieldShow titulo='Valor Líquido' descricao={clsFormatos.currency(rsPedido && rsPedido.valorTotalComImpostos ? rsPedido.valorTotalComImpostos : rsPedido && rsPedido.valorTotal ? rsPedido.valorTotal : 0)} />
          <CustomFieldShow titulo='Observação' descricao={rsPedido && rsPedido.observacao ? rsPedido.observacao : ''} />

          <CustomTituloShow titulo='Itens do Pedido' />

          <Grid item xs={12}>
            <DataTable cabecalho={CabecalhoItens} dados={rsPedido ? rsPedido.itemPedido : []} />
          </Grid>

          <CustomTituloShow titulo='Pagamento' />

          {rsPedido?.infPagamentoPedido.map((item, _index) =>
            <>
              <Condicional condicao={item.titulos.length > 0}>
                <CustomFieldShow titulo='Pagamento:' descricao={item.meioPagamento} />
                <Grid item xs={12}>
                  <DataTable cabecalho={CabecalhoTitulos} dados={item.titulos} />
                </Grid>
              </Condicional>
              <Condicional condicao={item.titulos.length === 0}>
                <CustomFieldShow titulo='Pagamento:' descricao={item.meioPagamento} />
                <CustomFieldShow titulo='Valor:' descricao={clsFormatos.currency(item.valor)} />
              </Condicional>
            </>
          )}

          <CustomTituloShow titulo='Dados de Transporte' />

          <CustomFieldShow titulo='Tipo Frete' descricao={rsPedido?.tipoFrete} />
          <CustomFieldShow titulo='Transportador' descricao={rsPedido?.transportador} />
          <CustomFieldShow titulo='Saida (Previsão)' descricao={rsPedido ? clsFormatos.dateMillsParaDateUser(rsPedido.dataPrevisaoSaida as any) : ''} />
          <CustomFieldShow titulo='Faturamento (Previsão)' descricao={rsPedido ? clsFormatos.dateMillsParaDateUser(rsPedido.dataPrevisaoFat as any) : ''} />


          <Grid item xs={12} sx={{ textAlign: 'right' }}>

            <Condicional condicao={!exibirConfirmacaoCancelamento && rsPedido?.situacaoPedidoIdentificador === SITUACAO_PEDIDO_APP}>
              <Button onClick={() => setExibirConfirmacaoCancelamento(true)}>Cancelar Pedido</Button>
            </Condicional>

            <Condicional condicao={exibirConfirmacaoCancelamento}>
              <Button sx={{ ml: 1 }} onClick={() => onCancelarPedido()}>Confirmar Cancelamento</Button>
              <Button onClick={() => setExibirConfirmacaoCancelamento(false)}>Não Cancelar</Button>
            </Condicional>

          </Grid>


          <Grid item xs={12} sx={{ textAlign: 'right' }}>

            <Condicional condicao={rsAssinatura.length !== 0}>
              <img src={rsAssinatura} alt="Assinatura" style={{ width: '500px', height: '200px' }} />
            </Condicional>

            <Condicional condicao={rsAssinatura.length === 0 && rsPedido?.situacaoPedidoIdentificador === SITUACAO_PEDIDO_APP}>
              <Button onClick={() => setExibirPedidoAssinatura(true)}>Assinar Pedido</Button>
            </Condicional>

          </Grid>


          <Grid item xs={12} sx={{ textAlign: 'right' }} displayPrint='none'>
            <Button onClick={() => onFecharExibicao(false)}>Fechar</Button>
          </Grid>

          <Grid item xs={12} sx={{ textAlign: 'right' }} displayPrint='none'>
            <Button onClick={btDownload}>Download PDF</Button>
          </Grid>


        </Grid>

        <ExibirJSONDev exibir={EMDESENVOLVIMENTO && true} oque={['rsPedido', rsPedido]} />

      </Dialog >

      <Dialog open={exibirPedidoAssinatura}>
        <Grid container sx={{ display: 'flex', alignItems: 'stretch', padding: 5 }}>

          <Grid item xs={12} sx={{ border: '2px solid #0F0F0F', padding: 0, margin: 0 }}>
            <SignatureCanvas penColor='blue'
              ref={assinaturaCanvas}
              canvasProps={{ width: 500, height: 200 }} />
          </Grid>

          <Grid item xs={12} sx={{ textAlign: 'right', mt: 2 }}>

            <Button onClick={() => onSalvarAssinatura()}>Salvar Assinatura</Button>
            <Button onClick={() => onCancelarAssinatura()}>Cancelar</Button>

          </Grid>

        </Grid>
      </Dialog>

    </>
  )

}